















































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

import LanguagesBtns from "@/components/app/shared/btn&dd/languages-btns.vue";
import BSwitch from "@/components/app/shared/switchs/b-switch.vue";
import StandartModal from "@/components/app/standart-modal.vue";

import type { ISection } from "@/@types/instructions/section";
import type { Locale, LanguageCode } from "@/@types/_shared/locale";
import type { SICON } from "@/@types/_shared/src";

@Component({
  components: {
    StandartModal,
    LanguagesBtns,
    BSwitch,
  },
  mixins: [validationMixin],
  validations: {
    name: { required },
  },
})
class InstructionsEditModal extends Vue {
  @Prop({ type: Object, default: null }) item!: ISection | null;

  defaultLocale: LanguageCode = this.$store.getters.getLanguages
    ? this.$store.getters.getLanguages[0]
    : "ru";
  currentLocale: LanguageCode = this.defaultLocale;

  show = true;
  name = "";
  names: Locale = {};
  icon = "";
  iconLib = "";

  iconLibs = ["bi", "material", "fa", "filoxenia", ""];

  get languages(): Array<string> {
    return this.$store.getters.getLanguages;
  }

  @Watch("currentLocale")
  changeLocale(): void {
    this.name = this.names[this.currentLocale] || "";
  }

  @Watch("name")
  changeName(): void {
    this.$set(this.names, this.currentLocale, this.name);
  }

  @Watch("item")
  autoFillingForm(): void {
    if (!this.item) return;
    this.names = { ...this.item.name };
    this.show = this.item.show;
    this.icon = this.item.src?.icon ? this.item.src.icon.icon : "";
    this.iconLib = this.item.src?.icon ? this.item.src.icon.lib : "";
    this.changeLocale();
  }

  onSubmit(e: Event): void {
    e.preventDefault();
    if (this.$v.$invalid) {
      this.$v.$touch();
      return;
    }

    this.$emit("save", {
      name: this.names,
      show: this.show,
      src: {
        icon: {
          icon: this.icon,
          lib: this.iconLib as SICON["lib"],
        },
      },
    });
    this.$bvModal.hide("instructions-edit");
  }

  isClean(): void {
    this.names = {};
    this.name = "";
    this.show = true;
    this.icon = "";
    this.iconLib = "";
    this.currentLocale = this.defaultLocale;
    this.$v.$reset();
  }
}
export default InstructionsEditModal;
